import { articleFields } from "../fragments";
export default `
  ${articleFields}
query($articleId: String! ,$type: String,) {
      itemStatusExist(articleId: $articleId, type: $type) {
        status
        buy_box_winner
        upId
        catalogId
        origen
        articles{
          ...articleFields
        }
      }
  }
`;